export default __webpack_public_path__ + "static/media/calendar_icon.69e7d4f1.png";